import { MapTo } from "@adobe/aem-react-editable-components";
import { Suspense, lazy } from "react";
import Spacer from "../Spacer/Spacer";
import { ButtonDownloadContractProps } from "./ButtonDownloadContract.types";

const ButtonDownloadContract = lazy(
	() =>
		import(
			/* webpackChunkName: 'buttonDownloadContract' */ "./ButtonDownloadContract"
		)
);

const ButtonDownloadContractConfig = {
	emptyLabel: "Botão Download de Contrato",

	isEmpty: function (props: ButtonDownloadContractProps) {
		return !props;
	},
};

const ButtonDownloadContractLoader = (props: ButtonDownloadContractProps) => {
	return (
		<Suspense
			fallback={
				<Spacer
					mobile={"48"}
					tablet={"48"}
					desktop={"48"}
					isInEditor={false}
					cqPath={""}
				/>
			}
		>
			<ButtonDownloadContract {...props} />
		</Suspense>
	);
};

MapTo<ButtonDownloadContractProps>(
	"alelo/components/content/v1/button-download-contract"
)(ButtonDownloadContractLoader, ButtonDownloadContractConfig);
